module.exports = __webpack_public_path__ + "static/gallery_wild_1-449348b024b4b0baedfbdd866039858f.jpg";